/* Creator Marketplace search is read-only. It only filters the products
 * returned for this creator by the authenticated marketplace endpoint. */
const normalizeSearch = (value) => String(value ?? "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLocaleLowerCase("es")
  .trim();

export function filterCreatorProducts(products, query, statusFilter = "all") {
  const needle = normalizeSearch(query);
  const list = Array.isArray(products) ? products : [];

  return list.filter((product) => {
    const matchesStatus = statusFilter === "all" || product.status === statusFilter;
    if (!matchesStatus) return false;
    if (!needle) return true;
    const nameAndCategory = normalizeSearch(`${product.name || ""} ${product.category || ""}`);
    return nameAndCategory.includes(needle);
  });
}
